import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { TRANSLATION_KEYS } from '../../../../../../../../../translations'

import { CurrentFQuarterWarning } from './components/currentFQuarterWarning/CurrentFQuarterWarning'
import { ToggleItem } from './components/toggleItem'
import { usePeriod } from './hooks/usePeriod'

import styles from './PeriodSelector.module.scss'

export const PeriodSelector: FC = () => {
  const {
    fYearsOptions,
    fQuartersOptions,
    selectedPeriodFYear,
    selectedPeriodFQuarters,
    handleChangeFQuarters,
    handleChangeFYear,
    showFQuarterWarning,
    closeFQuarterWarningDialog,
  } = usePeriod()

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <Translation text={TRANSLATION_KEYS.settings.period} />
      </div>
      <div className={styles.yearsContainer}>
        {fYearsOptions.map((fYear, index) => (
          <ToggleItem
            key={index}
            buttonClassName={styles.fYearButton}
            value={fYear}
            isActive={selectedPeriodFYear === fYear}
            onClick={handleChangeFYear}
          />
        ))}
      </div>
      <div className={styles.quartersContainer}>
        {fQuartersOptions.map((it, index) => {
          const match = selectedPeriodFQuarters.find((fQuarter) => fQuarter === it.fQuarter)

          return (
            <ToggleItem
              key={index}
              buttonClassName={styles.quarterButton}
              value={it.fQuarter}
              isActive={Boolean(match)}
              isDisabled={!it.isEnabled}
              onClick={handleChangeFQuarters}
            />
          )
        })}
      </div>
      <CurrentFQuarterWarning isShown={showFQuarterWarning} onClose={closeFQuarterWarningDialog} />
    </div>
  )
}
